// extracted by mini-css-extract-plugin
export default {"container":"TabsWrapper_container__B8lO+","wrapper":"TabsWrapper_wrapper__e9+CN"};